/**
 * A global namespace for `dblclick` event.
 */
const mousedblclickEvent = "dblclick";
export default mousedblclickEvent;
